<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import Style from "@/views/layouts/style"; 
import DontExist from "@/components/company/components/DontExist"
import puntuationAPI from "@/services/standards/puntuation/puntuationAPI";


/**
 * Form elements component
*/
export default {
  page: {
    title: "Configuración",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Style,
    DontExist,
   
  },
  data() {
    return {
      title: "Configuración",
      
      loading: true,
      items: [],
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companies_id: this.$store.getters["company/getCompany"].id || null,
       
    };
  },
  computed: {},

  methods: {
    getList() {
      puntuationAPI.getpuntuation(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          
          let identification = response.data;
          console.log(identification);
          this.lista = identification
          console.log('data a mostrar:', this.lista)
          this.loading= false;
        })
        .catch((error) => {
          console.log(error);
         
        });
    },

    getRole(name, roles) {

// Get the user role
let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

// If the user is logged
if (role) {

  // If the roles array is not empty
  if (roles) {

    // Know if the role indicated is in the roles array
    role = roles.includes(role) ? true : false

  } // Close if the roles arrays is not empty
  
  // If the roles arrays is empty
  else {

    // Know if the user role is in the roles indicated
    role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

  } // Close if the roles arrays is empty

  // Get the user permissions
  const permissions = this.$store.state.auth.info.permissions

  // Know if the user has the permission indicated
  const enabled = permissions.find(permission => permission.name === name)

  // If the user has the permission indicated and the user role is in the roles indicated
  return enabled && role ? true : false

} // Close if the user is logged

// If the user is not logged
else {
  return false
} // Close else the user is not logged
},
  },

   mounted() {
    this.getList()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if=" !loading && classificationID <= 4 ">  
   
    <div class="row">
      <div class="col-12">
        <div class="card">
         
          <div class="row" >
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <div class="form-row row text-center">
                        <form class="form-inline">
                       
                      
                        
                        </form>
                      </div>
                      </div> 
                      <div class="col-6">
                        <div class="form-group text-right m-b-0">
                
              </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                   
                      <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                        <thead >
                          <tr>
                           
                            <th class="text-center align-middle"><h4>Configuración</h4></th>
                            <th :hidden="!getRole('Crear', [1, 2]) || !getRole('Editar', [1, 2]) || !getRole('Consultar', [1, 2])" class="text-center align-middle"><h4>Acciones</h4></th>
                          </tr>
                        </thead>
                        <tbody  class="bg-white divide-y divide-gray-200">
                          <tr >
                           
                                          
                           <td class="text-center align-middle">
                            <h3> <span class="badge badge-pill badge-primary"
                    >Puntuación de los items</span
                  ></h3>
                            </td>
                            
                              <td :hidden="!getRole('Crear', [1, 2]) || !getRole('Editar', [1, 2]) || !getRole('Consultar', [1, 2])" class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item  :disabled="!getRole('Crear', [1, 2]) || !getRole('Editar', [1, 2]) || !getRole('Consultar', [1, 2])"   :to="{ path: `/forms/configuracion/puntuacion` } ">Ver</b-dropdown-item>
                                  </b-dropdown>
                              </div>
                            </td>
                          </tr>

                       
                        </tbody>
                      </table>
                    
                      <div>
                       
   </div>
                    </div>
                  </div>
                </div>
              
                <!-- end col -->
              </div>

         
        </div>
      </div>
   
 
  </div>
</div>

<div v-else-if=" !loading && classificationID > 3 " >
  <DontExist />
</div>

<div v-else-if="!loading">
  <DontExist />
</div>
<div v-else class="col-xl-12 text-center">
  <div class="text-center">
    <b-spinner variant="primary" label="Loading..."></b-spinner>
  </div>
</div> 
</div>
</div>
  </Layout>
</template>
